import React, { useContext, useEffect } from 'react'
import { defaultState, UserProfileResponse } from '../libs/fetchProfile'
import useProfile from '../libs/useProfile'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'

interface ProfileContextType extends UserProfileResponse {
  mutate: any;
}

export const ProfileContext = React.createContext<ProfileContextType>({
  ...defaultState,
  mutate: null
})

const { Provider } = ProfileContext

const ProfileProvider = ({ updateData, children }) => {

  const { hostUrl, cloudinaryEnv } = useContext(EnvVariablesContext)
  const { data, mutate } = useProfile(hostUrl, cloudinaryEnv)

  useEffect(() => {
    if (data) {
      updateData(data);
    }
  }, [data])

  return <Provider value={{ ...data, mutate }}>{ children }</Provider>

}

export default ProfileProvider
